class exports.Contracts_Edit_Select_Handler extends Handler
    init: () ->

        @layoutUrl = 'backend/portal/contracts/load-layout-add-select'
        @layoutSelector = App.sidebar.contentDiv().find('#edit')

        @subHandlers =
            'ContractDelete':
                'class': 'portal::handlers/contracts/Contracts_Delete_Dialog_Handler'

        @loadLayout()

    afterLoadLayout: () ->
        ths = this

        $('#contract_number').mask '99 - 9999 - 99',
            placeholder: ' '

        $('#contract_btn_back').bind 'click', () =>
            @parent.dlg_handler.refresh()
            @parent.unloadContract()

        $('#contract_btn_delete').bind 'click', () =>
            handler = @createSubHandler('ContractDelete')
            if handler
                handler.loadLayoutPostOptions = contract_id: $('#contract_id').val()
                handler.init()

        @parent.dlg_handler.loadFields()
        @parent.makeValidation('Saving Contract')
